import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import InputMask from 'react-input-mask';

import { DateUtils } from 'react-day-picker';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';

import 'moment/locale/ru';

import { Icon } from 'components/Icon';

import 'react-day-picker/lib/style.css';
import './style.scss';

const DatePicker = ({ value, onChange }) => {
  const [selectTime, setSelectTime] = useState(false);
  const [timeInput, setTimeInput] = useState('');
  const [errors, setErrors] = useState({});

  const timeList = [
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
  ];

  const timeInDate = useMemo(() => {
    return moment(value.getTime()).format('HH:mm');
  }, [value]);

  useEffect(() => {
    setTimeInput(timeInDate);
  }, [timeInDate]);

  const handleDateChange = (date) => {
    const [hour, minutes] = timeInDate.split(':');
    date.setHours(hour);
    date.setMinutes(minutes);
    if (!DateUtils.isDate(date) || date < new Date()) {
      setErrors({ ...errors, date: true });
      return;
    }

    errors.date && setErrors({});
    onChange(date);
  };

  const handleSelectTime = () => {
    setSelectTime(!selectTime);
  };

  const handleInputTime = ({ target: { value } }) => {
    setTimeInput(value);
    handleTime(value);
  };

  const handleTime = (time) => {
    const [hour, minute] = time.split(':');
    setSelectTime(false);

    if (hour && minute) {
      const newTime = new Date(value.getTime());
      newTime.setHours(hour);
      newTime.setMinutes(minute);

      if (DateUtils.isDate(newTime) && Date.now() <= newTime.getTime()) {
        errors.time && setErrors({ ...errors, time: undefined });
        onChange(newTime);
        return;
      }
    }

    !errors.time && setErrors({ ...errors, time: true });
  };

  const datePickerContainer = errors.date ? 'datepicker-container-error' : 'datepicker-container';

  return (
    <>
      <div className="date-picker-group">
        <InputMask mask="99:99" value={timeInput} onChange={handleInputTime}>
          {(inputProps) => (
            <input {...inputProps} type="text" className={`date-picker-input ${errors.time ? 'errors' : ''}`} />
          )}
        </InputMask>

        <div className="date-picker-selector">
          <Icon name="datepicker" onClick={handleSelectTime} />

          {selectTime && (
            <div className="date-picker-modal dropdownScroll">
              {timeList.map((item) => (
                <div className="date-picker-option" key={item} onClick={() => handleTime(item)}>
                  {item}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <DayPickerInput
        value={value}
        classNames={{
          container: datePickerContainer,
          overlayWrapper: 'datepicker-orverlay-wrapper',
          overlay: 'datepicker-overlay',
        }}
        onDayChange={handleDateChange}
        formatDate={formatDate}
        parseDate={parseDate}
        format="L"
        placeholder={`${formatDate(new Date(), 'L', 'ru')}`}
        dayPickerProps={{
          locale: 'ru',
          localeUtils: MomentLocaleUtils,
          firstDayOfWeek: 1,
        }}
      />
    </>
  );
};

DatePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};

DatePicker.defaultProps = {
  value: new Date(),
};

export { DatePicker };
